// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { getFastenersTableApiParameter } from "@store/Framework/Store/Store/Components/FastenersTable/FastenersTableSelector";

export const getFastenersTableDataView = (state: ApplicationState, productId: string) => {
    const fastenersTableApiParameter = getFastenersTableApiParameter(state);

    return getDataView(state.data.products, {
        ...fastenersTableApiParameter,
        productId,
        pageSize: 5,
    });
};

export const getLengthCollection = (state: ApplicationState) => state.store.data.fasteners.lengthCollection;
export const getBoxCountCollection = (state: ApplicationState) => state.store.data.fasteners.boxCountCollection;
export const getHeadDiameterCollection = (state: ApplicationState) => state.store.data.fasteners.headDiameterCollection;
export const getThreadCollection = (state: ApplicationState) => state.store.data.fasteners.threadCollection;
export const getDriveTypeCollection = (state: ApplicationState) => state.store.data.fasteners.driveTypeCollection;
export const getPointCollection = (state: ApplicationState) => state.store.data.fasteners.pointCollection;
export const getHeadCollection = (state: ApplicationState) => state.store.data.fasteners.headCollection;
export const getFinishCollection = (state: ApplicationState) => state.store.data.fasteners.finishCollection;
